module.exports = __webpack_public_path__ + "img/delta_background - small.565a5e74.png";